module.exports = __webpack_public_path__ + "img/hallux_valgus_perfect_results.ff141a7e.png";